
//动态扩散圆
function DynamicCircleAMaterialProperty(options) {
    this._definitionChanged = new Cesium.Event();
    this._color = undefined; //颜色
    this._colorSubscription = undefined;

    this.color = options.color;
    this.time = options.time; //速度
}
Object.defineProperties(DynamicCircleAMaterialProperty.prototype, {
    isConstant: {
        get: function () {
            return false;
        }
    },
    definitionChanged: {
        get: function () {
            return this._definitionChanged;
        }
    },
    color: Cesium.createPropertyDescriptor('color'),
    time: Cesium.createPropertyDescriptor('time')
});
DynamicCircleAMaterialProperty.prototype.getType = function (time) {
    return  Cesium.Material.DynamicCircleAType;
}
DynamicCircleAMaterialProperty.prototype.getValue = function (time, result) {
    if (!Cesium.defined(result)) {
        result = {};
    }
    //1、property 2、time 3、default 4、result
    result.color = Cesium.Property.getValueOrClonedDefault(this._color, time, Cesium.Color.RED, result.color);

     //1、property 2、time 3、default 4、result
    result.time=Cesium.Property.getValueOrDefault(this.time, time, 10, result.time);
    return result;
}

DynamicCircleAMaterialProperty.prototype.equals = function (other) {
    return this === other ||
        (other instanceof DynamicCircleAMaterialProperty &&
            Cesium.Property.equals(this._color, other._color))
}


export default DynamicCircleAMaterialProperty;